import './src/scss/promotional-details.scss';
//LEAVE THIS FILE ALONE - IT'S JUST HERE TO COMPILE YOUR SCSS INTO CSS


// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/marketing-campaigns_deploy_trigger_imp_v2/package/app.js